import React, { useEffect, useState } from 'react';
import { EventEmitter } from 'eventemitter3';
import UIGameAchievement from './UIGameAchievement.tsx';
import { PlayerColor } from '@colonist/game-states';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
export const UIGameAchievementEventEmitter = new EventEmitter();
export const UIGameAchievementContainer = ()=>{
    const [achievements, setAchievements] = useState([]);
    const isReplay = useIsReplay();
    useEffect(()=>{
        const addAchievement = (achievement)=>{
            if (isReplay === true) return;
            setAchievements((prev)=>[
                    ...prev,
                    achievement
                ]);
        };
        UIGameAchievementEventEmitter.on('addAchievement', addAchievement);
        return ()=>{
            UIGameAchievementEventEmitter.off('addAchievement', addAchievement);
        };
    }, [
        isReplay
    ]);
    const handleDisappear = ()=>{
        setAchievements((prev)=>prev.slice(1));
    };
    const firstAchievement = achievements[0];
    if (firstAchievement == undefined) return null;
    const key = `${firstAchievement.achievementOwnerNew}-${firstAchievement.achievementType}-${firstAchievement.achievementScore}`;
    return /*#__PURE__*/ React.createElement(UIGameAchievementWrapper, {
        key: key,
        ...firstAchievement,
        onDisappear: handleDisappear
    });
};
const UIGameAchievementWrapper = ({ achievementOwnerNew, achievementOwnerPrevious, achievementType, achievementScore, onDisappear })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const isConfettiEnabled = achievementOwnerNew === myColor;
    const getUserState = useGameStore((state)=>state.gameUserStates.getUserState);
    const achievementOwnerNewUserState = getUserState(achievementOwnerNew);
    const isPreviousOwnerDefined = achievementOwnerPrevious != undefined && achievementOwnerPrevious !== PlayerColor.None;
    const achievementOwnerPreviousUserState = isPreviousOwnerDefined ? getUserState(achievementOwnerPrevious) : undefined;
    const translationKeyContext = useGameStore((state)=>state.gameMode.translationKeyContext);
    return /*#__PURE__*/ React.createElement(UIGameAchievement, {
        isConfettiEnabled: isConfettiEnabled,
        achievementOwnerNew: achievementOwnerNewUserState,
        achievementOwnerPrevious: achievementOwnerPreviousUserState,
        achievementType: achievementType,
        achievementScore: achievementScore,
        translationContext: translationKeyContext,
        onDisappear: onDisappear
    });
};
